type DomainCSP = string[];


const createNonce = (): string => {
  const bytes = new Uint8Array(16);
  crypto.getRandomValues(bytes);
  // Base64url encode without padding for URL/attribute-safe nonce
  return btoa(String.fromCharCode(...bytes))
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=+$/, '');
};

function insertNonceToScripts(nonce: string): void {
  const addNonce = (el: Element): void => {
    el.setAttribute('nonce', nonce);
  };

  const scripts = document.querySelectorAll('head script');
  const noScripts = document.querySelectorAll('head noscript');

  scripts.forEach(addNonce);
  noScripts.forEach(addNonce);
}

function createMetaCSP(domains: DomainCSP, nonce: string): void {
  window.document
    .querySelector("meta[http-equiv='Content-Security-Policy']")
    ?.remove();

  // Detectar si estamos en entorno de testing (Karma/Jasmine)
  const win = window as unknown as Record<string, unknown>;
  const isTestEnvironment =
    typeof win['__karma__'] !== 'undefined' ||
    typeof win['jasmine'] !== 'undefined';

  const domainsInject = [
    'script-src',
    `'nonce-${nonce}'`,
    "'self'",
    ...(isTestEnvironment ? ["'unsafe-eval'"] : []),
    ...domains
  ];

  const meta = document.createElement('meta');
  meta.setAttribute('http-equiv', 'Content-Security-Policy');
  meta.setAttribute('content', domainsInject.join(' '));
  meta.setAttribute('data-nonce', nonce);
  window.document.head.appendChild(meta);
}

let currentNonce = '';

export function insertCSP(domains: DomainCSP): string {
  currentNonce = createNonce();
  insertNonceToScripts(currentNonce);
  createMetaCSP(domains, currentNonce);
  return currentNonce;
}

/**
 * @internal Resets the cached nonce. Only for unit testing.
 */
export function _resetCSPState(): void {
  currentNonce = '';
}

/**
 * Returns the current CSP nonce value.
 */
export function getCSPNonce(): string {
  if (!currentNonce) {
    const meta = document.querySelector(
      "meta[http-equiv='Content-Security-Policy']"
    );
    currentNonce = meta?.getAttribute('data-nonce') ?? '';
  }
  return currentNonce;
}

export function addNonceToHtml(html: string): string {
  const nonce = getCSPNonce();
  if (!nonce) {
    return html;
  }
  // Add nonce to <script> tags that don't already have one
  return html.replace(
    /<script(?![^>]*\bnonce\b)/gi,
    `<script nonce="${nonce}"`
  );
}
